<template>
  <div class="videoPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>审核状态：</div>
          <el-select v-model="examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable
                     placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':2,'value':'审核中'},{'key':1,'value':'审核通过'},{'key':0,'value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>视频标题：</div>
          <el-input clearable placeholder="请输入搜索内容" size="small" style="width: 180px;margin-right: 10px"
                    v-model="title"></el-input>
          <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button size="small" type="success" @click="addBtn">新增</el-button>
        </div>

        <el-table
            size="small"
            tooltip-effect="dark"
            ref="multipleTable"
            :data="tableData"
            border
            style="width: 100%;margin-top: 30px">
          <el-table-column label="视频标题" prop="title" align="center"/>
          <el-table-column label="视频说明" width="400" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{ scope.row.remark }}
                </template>
                <span
                    style="width:380px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{
                    scope.row.remark
                  }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="视频" prop="ossUrl" width="200" align="center">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-button @click="viewVideoBtn(scope.row)" size="small" type="text">播放</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" width="100" align="center">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-tag v-if="scope.row.examineStatus == '2'" type="warning"
                        size="small" effect="dark">待审核
                </el-tag>
                <el-tag v-else-if="scope.row.examineStatus == '1'" type="success" size="small" effect="dark">审核通过
                </el-tag>
                <el-tag v-else-if="scope.row.examineStatus == '0'" type="danger" size="small" effect="dark">审核未通过
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="240"
          >
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row)" v-if="scope.row.examineStatus == '0'"
                         size="small" type="success">修改
              </el-button>
              <el-button @click="delBtn(scope.row)"
                         size="small" type="danger">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>

    <a-modal
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="500px"
        @cancel="addCancel"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="视频标题" prop="title">
          <el-input v-model="ruleForm.title" style="width: 300px" size="small" placeholder="请输入视频标题"></el-input>
        </el-form-item>
        <el-form-item label="视频说明" prop="remark">
          <el-input v-model="ruleForm.remark" type="textarea" :rows="5" style="width: 300px" size="small"
                    placeholder="请输入视频说明"></el-input>
        </el-form-item>
        <el-form-item label="视频文件" prop="ossUrl">
          <div v-if="ruleForm.ossUrl" style="display: flex;align-items: center">
            <video
                   :src="ruleForm.ossUrl"
                   controls="controls"
                   style="width:240px;height:120px"
            ></video>
            <el-button @click="chooseVideoBtn" style="margin-left: 5px;" type="danger" size="mini">删除</el-button>
          </div>

          <a-upload v-else
              :action="uploadApiUrl"
              name="img"
              ref="upload"
              :supportServerRender="true"
              @change="videoChange"
          >
            <a-button type="primary"> <a-icon type="upload"/> 上传视频 </a-button>
          </a-upload>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="delDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="delCancel"
        @ok="delSubmit"
    >
      <div>是否删除该条记录？</div>
    </a-modal>

    <a-modal
        :visible="videoDialogState"
        title="视频"
        width="1200px"
        @cancel="videoDialogCancel"
    >
      <template slot="footer">
        <a-button key="back" v-show="false">
          Return
        </a-button>
        <a-button @click="videoDialogCancel" key="submit" v-show="true">
          关闭
        </a-button>
      </template>
      <video-player class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions">
      </video-player>
    </a-modal>

  </div>
</template>
<script>
import {baseURL} from "@/api/config";

export default {
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  data() {
    return {
      dialogTitle: '',
      pageNum: 1,
      pageSize: 20,
      examineStatus: null,
      title: null,
      tableData: [],
      totalElements: 0,//数据总数
      addDialogState: false,
      ruleForm: {
        id: null,
        authorId: localStorage.getItem("loginId"),
        title: '',
        remark: '',
        ossUrl: '',
      },
      rules: {
        title: [{required: true, message: "请输入视频标题", trigger: "blur"}],
        remark: [{required: true, message: "请输入视频说明", trigger: "blur"}],
        ossUrl: [{required: true, message: "请上传视频文件", trigger: "blur"}],
      },
      uploadApiUrl: null,
      delDialogState: false,
      delId: null,
      videoDialogState: false,
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: 'auto',
        language: 'zh-CN',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: '16:9',
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [{
          //类型
          type: "video/mp4",
          //url地址
          src: ''
        }],
        //你的封面地址
        poster: '',
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      }
    };
  },
  methods: {
    viewVideoBtn(row){
      this.playerOptions.poster = row.frontCoverUrl
      this.playerOptions.sources[0].src = row.ossUrl
      this.videoDialogState = true
    },
    videoDialogCancel(){
      this.player.pause()
      this.videoDialogState = false
    },
    chooseVideoBtn(){
      this.ruleForm.ossUrl = null
    },
    videoChange(file) {
      if(file.file.response && file.file.response.entity){
        console.log('上传成功',file.file.response.entity)
        this.ruleForm.ossUrl = file.file.response.entity
      }
    },
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.examineStatus = null
      this.title = null
      this.getList()
    },
    addBtn() {
      this.dialogTitle = '新增'
      this.ruleForm.id = null
      this.ruleForm.title = ''
      this.ruleForm.remark = ''
      this.ruleForm.ossUrl = ''
      this.addDialogState = true
    },
    editBtn(row) {
      this.dialogTitle = '编辑'
      this.ruleForm.id = row.id
      this.ruleForm.title = row.title
      this.ruleForm.remark = row.remark
      this.ruleForm.ossUrl = row.ossUrl
      this.addDialogState = true
    },
    delBtn(row) {
      this.delId = row.id
      this.delDialogState = true
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === '新增') {
            this.postAxios("/video/insert", this.ruleForm).then(res => {
              if (res.success) {
                this.$message.success("添加成功!")
                this.addDialogState = false
                this.getList()
              }
            });
          } else {
            this.postAxios("video/update", this.ruleForm).then(res => {
              if (res.success) {
                this.$message.success("修改成功!")
                this.addDialogState = false
                this.getList()
              }
            });
          }
        }
      });
    },
    getList() {
      this.postAxios("/video/list", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        authorId: localStorage.getItem("loginId"),
        title: this.title,
        examineStatus: this.examineStatus === '' ? null : this.examineStatus
      }).then(res => {
        if (res.success) {
          this.tableData = res.content;
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    delCancel() {
      this.delDialogState = false
    },
    delSubmit(){
      this.getAxios("/video/delete?id=" + this.delId).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.delId = null
          this.deleteDialogState = false
          this.getList()
        }
      })
    }
  },
  created() {
    this.uploadApiUrl = baseURL + '/file/uploadFile'
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.cover-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.cover-uploader .el-upload:hover {
  border-color: #409EFF;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  border: 1px dashed #d9d9d9;
  width: 300px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.cover {
  width: 300px;
  height: 150px;
  display: block;
}
</style>
